import {
  Input as OriginalInput,
  BrandingFooter as OriginalBrandingFooter,
  PrivacyBox as OriginalPrivacyBox,
  PrivacyTerms as OriginalPrivacyTerms,
  Header as OriginalHeader,
} from "@volumental/common";
import type { InputProps, HeaderProps, PrivacyBoxProps, PrivacyTermsProps, BrandingProps } from "@volumental/common";
import type React from "react";
import { useTranslation } from "react-i18next";

export function Input(props: Omit<InputProps, "crossAriaLabel" | "searchIconAlt">): React.JSX.Element {
  const { t } = useTranslation();

  return <OriginalInput {...props} crossAriaLabel={t("ariaLabels.clearBT")} searchIconAlt={t("imageAlt.searchIcon")} />;
}

export function BrandingFooter(props: Omit<BrandingProps, "ariaLabel" | "altText">): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <OriginalBrandingFooter
      {...props}
      ariaLabel={t("ariaLabels.brandingFooter")}
      altText={t("imageAlt.poweredByVol")}
    />
  );
}

export function PrivacyBox(props: Omit<PrivacyBoxProps, "ariaLabel" | "altText">): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <OriginalPrivacyBox {...props} ariaLabel={t("ariaLabels.privacyFooter")} altText={t("imageAlt.poweredByVol")} />
  );
}

export function PrivacyTerms(props: Omit<PrivacyTermsProps, "ariaLabel">): React.JSX.Element {
  const { t } = useTranslation();

  return <OriginalPrivacyTerms {...props} ariaLabel={t("ariaLabels.privacyTermsFooter")} />;
}

export function Header(
  props: React.PropsWithChildren<Omit<HeaderProps, "ariaLabelBack" | "ariaLabelClose" | "altBack" | "altClose">>
): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <OriginalHeader
      {...props}
      ariaLabelBack={t("ariaLabels.backBT")}
      ariaLabelClose={t("ariaLabels.closeBT")}
      altBack={t("imageAlt.back")}
      altClose={t("imageAlt.closeIcon")}
    />
  );
}
